import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData, postFile } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisible } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast";
import AlertInterface from "features/toast/toastInterface";


interface DiplomadoState {
    status: string;
    error: string;
    diplomadoList: any[],
    diplomadoListActive: any[],
    diplomado: {
        idDiplomado: number | null;
        nombre: string | null;
        descripcion: string | null;
        explicacion: string | null;
        requisitos: string | null;
        edadMinima: number | null;
        edadMaxima: number | null;
        fileImage: string | null;
        fileUrl: string | null;
        fileData: string | null;
        estado: number | null;
    }

}

const initialState: DiplomadoState = {
    status: 'idle',
    error: '',
    diplomadoList: [],
    diplomadoListActive: [],
    diplomado: {
        idDiplomado: null,
        nombre: null,
        descripcion: null,
        explicacion: null,
        requisitos: null,
        edadMinima: null,
        edadMaxima: null,
        fileUrl: null,
        fileImage: null,
        fileData: null,
        estado: null
    }
}

export const fetchDiplomado = createAsyncThunk('fetchDiplomado', async (_: any, { dispatch,getState, rejectWithValue }) => {
    const idsp = 60;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const modifyCreateDiplomado = createAsyncThunk('modifyCreateDiplomado', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    
    const diplomadoNew = selectDiplomado(state);
    const diplomadoAttributes = { ...diplomadoNew }
    const idsp = diplomadoAttributes.idDiplomado ? 58 : 57;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...diplomadoAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
        if (diplomadoAttributes.fileData != null && diplomadoAttributes.fileData !== '') {
            const { result } = await postFile({  idsp:76, id: data, dir: "diplomado", fileData: diplomadoAttributes.fileData, fileName: data }, getState, dispatch);
            if (!result) {
                alert = { title: 'ACCIÓN INCOMPLETA', message: "IMAGEN NO SE HA PODIDO GUARDAR", data: [], type: 'Crimson', time: Date.now() };
            }
        }
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisible(false));
    }

    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchDiplomado({}));
    return rejectWithValue(message);
});

export const updateEstadoDiplomado = createAsyncThunk('updateEstadoDiplomado', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    
    const diplomadoNew = selectDiplomado(state);
    const diplomadoAttributes = { ...diplomadoNew }
    const estado = !diplomadoAttributes.estado;
    const idDiplomado = diplomadoAttributes.idDiplomado;
    const idsp = 59;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, estado, idDiplomado }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisible(false));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchDiplomado({}));
    return rejectWithValue(message);
});


export const diplomadoSlice = createSlice({
    name: 'diplomado',
    initialState,
    reducers: {
        setDiplomadoList: (state, action) => {
            state.diplomadoList = action.payload;
        },
        setDiplomadoListActive: (state, action) => {
            state.diplomadoListActive = action.payload;
        },
        setDiplomado: (state, action) => {
            state.diplomado = !action.payload ? initialState.diplomado : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchDiplomado.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDiplomado.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.diplomadoList = data ? data : [];

            })
            .addCase(fetchDiplomado.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(modifyCreateDiplomado.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(modifyCreateDiplomado.fulfilled, (state, action) => {
                state.status = 'completed';
            })
            .addCase(modifyCreateDiplomado.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(updateEstadoDiplomado.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateEstadoDiplomado.fulfilled, (state, action) => {
                state.status = 'completed';

            })
            .addCase(updateEstadoDiplomado.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectDiplomadoList = (state: RootState) => state.diplomado.diplomadoList;
export const selectDiplomadoListActive = (state: RootState) => state.diplomado.diplomadoListActive;
export const selectDiplomado = (state: RootState) => state.diplomado.diplomado;

export const { setDiplomadoList, setDiplomadoListActive, setDiplomado } = diplomadoSlice.actions;

export default diplomadoSlice.reducer;